import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'

import { CustomIcon } from 'src/components'
import i18n from 'src/i18n'

import { ShowSchedulePostsButtonBox } from './styles'
import { ShowSchedulePostsButtonProps } from './showSchedulePostsButton.types'

const ShowSchedulePostsButton = ({ onClick }: ShowSchedulePostsButtonProps) => {
  return (
    <ShowSchedulePostsButtonBox className="_d-flex _mt-4">
      <button
        className="hot-button _d-flex _flex-1 _align-items-center _border _bg-transparent _p-4"
        data-test="show-schedule-posts-button"
        onClick={onClick}
      >
        <span className="_d-flex _flex-column _align-items-start">
          <span className="btn-title _text-gray-900">
            {i18n.t('modals.schedule_posts.buttons.show_schedule_posts')}
          </span>
          <span className="btn-detail _text-gray-500">
            {i18n.t('modals.schedule_posts.buttons.show_schedule_posts_detail')}
          </span>
        </span>
        <span className="_ml-auto btn-icon _p-2 _d-flex">
          <CustomIcon icon={faArrowRight} />
        </span>
      </button>
    </ShowSchedulePostsButtonBox>
  )
}

export default ShowSchedulePostsButton
